import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddEmployee = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/employee`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddSubordinate = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/line-manager`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onUpdateContactDetails = async (id: any, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/emergency-contact/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onUpdateKinDetails = async (id: any, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/next-of-kin/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onUpdateEmployeeDetails = async (id: any, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/employee/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddEmployeeKin = async (postData: any, config: any) => {
  try {
    const response = await axios.post(
      `${baseURL}/next-of-kin`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddEmployeeemgContact = async (postData: any, config: any) => {
  try {
    const response = await axios.post(
      `${baseURL}/emergency-contact`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOrgemployees = async (id: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/employee/organization/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

 
const onGetemployeeKin = async (id: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/next-of-kin/employee/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetemployeeEmgContact = async (id: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/emergency-contact/employee/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onGetEmployeeByID = async (id: any, config: any) => {
  try {
    const response = await axios.get(`${baseURL}/employee/${id}`, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetSubordinates = async (id: any, config: any) => {
  try {
    const response = await axios.get(`${baseURL}/line-manager/sub-ordinates/${id}`, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const ToggleIsLineManager = async (postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/employee/line-management`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

export {
  onAddEmployee,
  onGetemployeeKin,
  onAddEmployeeemgContact,
  onGetemployeeEmgContact,
  onGetOrgemployees,
  onAddEmployeeKin,
  onGetEmployeeByID,
  onUpdateKinDetails,
  onAddSubordinate,
  ToggleIsLineManager,
  onUpdateContactDetails,
  onGetSubordinates,
  onUpdateEmployeeDetails,
};
